import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const serviceList = [
  {
    icon: FiIcons.FiHome,
    title: "Sgombero appartamenti e case",
    desc: "Svuotiamo totalmente o parzialmente appartamenti, case e ville per traslochi, eredità, vendite e ristrutturazioni."
  },
  {
    icon: FiIcons.FiArchive,
    title: "Sgombero cantine, solai e box",
    desc: "Liberiamo in poche ore cantine, soffitte, solai e box auto da mobili, scatoloni e oggetti accumulati negli anni."
  },
  {
    icon: FiIcons.FiBriefcase,
    title: "Sgombero uffici e locali commerciali",
    desc: "Sgombero rapido di uffici, negozi e locali per chi cambia sede, chiude o rinnova."
  },
  {
    icon: FiIcons.FiLayers,
    title: "Sgombero magazzini e capannoni",
    desc: "Grand volumi gestiti con mezzi e squadra adeguati, per aziende e attività."
  },
  {
    icon: FiIcons.FiTruck,
    title: "Sgombero post ristrutturazione",
    desc: "Rimuoviamo materiali di risulta e ingombranti dopo lavori edili e cantieri."
  },
  {
    icon: FiIcons.FiShieldCheck,
    title: "Smaltimento a norma di legge",
    desc: "Trasportiamo e conferiamo ogni materiale in discariche e piattaforme ecologiche autorizzate."
  }
];

export default function Services() {
  return (
    <section className="py-24 bg-[#080808] border-y border-white/5">
      <div className="container mx-auto px-5">
        <motion.h2 
          className="text-4xl md:text-6xl font-display uppercase italic mb-16 text-center md:text-left"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          I nostri servizi di <span className="text-maaich-lime">sgombero</span>
        </motion.h2>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
          {serviceList.map((service, idx) => (
            <motion.div 
              key={idx}
              className="flex flex-col md:flex-row items-center md:items-start gap-4 md:gap-6 p-6 md:p-8 bg-white/5 border border-white/10 hover:border-maaich-lime/30 transition-all group"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex-shrink-0 bg-maaich-black border border-maaich-lime rounded-full flex items-center justify-center group-hover:bg-maaich-lime group-hover:text-black transition-colors duration-300">
                <SafeIcon icon={service.icon} className="text-2xl md:text-3xl text-maaich-lime group-hover:text-black" />
              </div>
              <div className="text-center md:text-left">
                <h3 className="font-display uppercase text-xl italic mb-3 text-white group-hover:text-maaich-lime transition-colors">{service.title}</h3>
                <p className="text-white/50 font-body text-sm leading-relaxed">{service.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}